function getSkillLabel(skillName) {
  if (!skillName || typeof skillName !== 'string') {
    return 'Skill'
  }

  if (/\b1h\b/i.test(skillName)) return '1H'
  if (/\b2h\b/i.test(skillName)) return '2H'

  return skillName
}

function formatQualifiedDamage(skills) {
  return skills
    .map((skill) => `${getSkillLabel(skill.name)} (${skill.damage_dice.trim()})`)
    .join(' / ')
}

export default function getWeaponDamageDice(item, characterSkills = null) {
  const itemType = item?.effective_type ?? item?.actual_type ?? item?.type

  if (itemType !== 'Melee Weapon' && itemType !== 'Ranged Weapon') {
    return item?.damage_dice ?? ''
  }

  const linkedSkills = Array.isArray(item?.skills)
    ? item.skills.filter(
        (skill) =>
          skill && typeof skill.damage_dice === 'string' && skill.damage_dice.trim() !== '',
      )
    : []

  if (!linkedSkills.length) {
    return item?.damage_dice ?? ''
  }

  const characterSkillNames = Array.isArray(characterSkills)
    ? new Set(
        characterSkills
          .map((skill) => skill?.display_name ?? skill?.name)
          .filter((name) => typeof name === 'string' && name.trim() !== ''),
      )
    : null

  const matchingCharacterSkills = characterSkillNames
    ? linkedSkills.filter((skill) => characterSkillNames.has(skill.name))
    : []

  if (matchingCharacterSkills.length === 1) {
    return matchingCharacterSkills[0].damage_dice.trim()
  }

  if (matchingCharacterSkills.length > 1) {
    return formatQualifiedDamage(matchingCharacterSkills)
  }

  const uniqueDamageDice = [...new Set(linkedSkills.map((skill) => skill.damage_dice.trim()))]

  if (uniqueDamageDice.length === 1) {
    return uniqueDamageDice[0]
  }

  return formatQualifiedDamage(linkedSkills)
}
